import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initializeCsrfToken } from './services/api'
import './index.css'

initializeCsrfToken().catch((error) => {
  console.warn('[CSRF] Failed to initialize token:', error)
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
